<template>
    <div class="container">
        <content-loader
                :height="20"
                :width="20"
                primaryColor="#ebebeb"
                secondaryColor="#f5f5f5"
                class="checkbox"
        >
            <rect x="0" y="0" rx="3" ry="3" width="20" height="20" />
        </content-loader>
        <content-loader
                :height="16"
                :width="textWidth()"
                primaryColor="#ebebeb"
                secondaryColor="#f5f5f5"
                class="text"
        >
            <rect x="0" y="0" rx="1" ry="1" :width="textWidth()" height="12" />
        </content-loader>
    </div>
</template>

<script>
    export default {
        name: "CheckboxPreloader",
        props: {
            long: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                shortWidth: 109,
                longWidth: 132,
            }
        },
        methods: {
            textWidth() {
                return this.long ? this.longWidth : this.shortWidth;
            }
        }
    }
</script>

<style scoped lang="scss">
.container {
    position: relative;
    display: flex;
    padding: 0;
}
.checkbox {
    position: relative;
    width: 20px;
    height: 20px;
}
.text {
    position: relative;
    height: 14px;
    left: 8px;
    top: -3px;
}
</style>